import { generatePath } from 'react-router-dom'
import dayjs from 'dayjs'
import noop from 'lodash/noop'
import isUndefined from 'lodash/isUndefined'
import isArray from 'lodash/isArray'
import isEmpty from 'lodash/isEmpty'
import omitBy from 'lodash/omitBy'

// new URLSearchParams(query) returns + for white spaces instead of %20
function encodeQueryData(data: Record<string, any>) {
  const query = []
  for (const d in data) {
    query.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
  }

  const queryStr = query.join('&')
  return queryStr ? `?${queryStr}` : queryStr
}

export const getRoutePath = (url: string, params: Record<string, any> = {}, query: Record<string, any> = {}) => {
  const resultPath = generatePath(url, params)
  const queryParams = encodeQueryData(query)

  return `${resultPath}${queryParams}`
}

export const formatMoney = (amount: number | string, currency: string | null = 'RUB'): string =>
  Number(amount).toLocaleString('ru-RU', { style: 'currency', currency: currency ?? 'RUB' })

export const formatDate = (date: number, withHours = false): string =>
  dayjs(date)
    .utc(false)
    .format(`DD.MM.YYYY${withHours ? ' HH:mm' : ''}`)

type AnyFunction = (...args: any[]) => any
export const preventHandler = (handler: AnyFunction, isLoading: boolean) => (isLoading ? noop : handler)

export const filterRequestParams = (value: any): boolean =>
  value === '' || isUndefined(value) || (isArray(value) && isEmpty(value))

export const omitRequestParams = <T = Record<string, unknown>>(params: T) => omitBy(params ?? {}, filterRequestParams)

export const downloadFile = (path: string, filename: string): void => {
  // Create a new link
  const anchor = document.createElement('a')
  anchor.href = path
  anchor.download = filename

  // Append to the DOM
  document.body.appendChild(anchor)

  // Trigger `click` event
  anchor.click()

  // Remove element from DOM
  document.body.removeChild(anchor)
}
